import { render, staticRenderFns } from "./RateLessonDialog.vue?vue&type=template&id=ec97b364&scoped=true&"
import script from "./RateLessonDialog.vue?vue&type=script&lang=js&"
export * from "./RateLessonDialog.vue?vue&type=script&lang=js&"
import style0 from "./RateLessonDialog.vue?vue&type=style&index=0&id=ec97b364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec97b364",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
